import { useUpdateScreenChatContext } from '$tablet-app/src/app/chat/hooks';
import { RootStackScreenProps } from '$tablet-app/src/app/navigation/RootStackNavigator/RootStackNavigator';
import { VideoCallScreen } from './VideoCallScreen';

export const VideoCallScreenWrapper = (
  props: RootStackScreenProps<'VideoCall'>
) => {
  const {
    navigation,
    route: {
      params: { url },
    },
  } = props;

  useUpdateScreenChatContext();

  return <VideoCallScreen url={url} onLeave={navigation.goBack} />;
};
